import React, { useEffect, useState } from "react";
import API from "../api";
import { Form, Button, Table } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";

export default function ContestEntryPage() {
  const { user } = useAuth();
  const [weeks, setWeeks] = useState([]);
  const [players, setPlayers] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [challenges, setChallenges] = useState([]);
  const [winners, setWinners] = useState({});

  useEffect(() => {
    const fetchWeeks = async () => {
      try {
        const res = await API.get(`/league/${user.leagueid}/weeks`);
        setWeeks(res.data);
      } catch (err) {
        console.error("Failed to fetch weeks", err);
      }
    };

    const fetchPlayers = async () => {
      try {
        const res = await API.get(`/players`);
        setPlayers(res.data);
      } catch (err) {
        console.error("Failed to fetch players", err);
      }
    };

    fetchWeeks();
    fetchPlayers();
  }, [user.leagueid]);

  const handleWeekChange = async (e) => {
    const weekId = parseInt(e.target.value);
    const week = weeks.find(w => w.id === weekId);
    setSelectedWeek(week);

    try {
      const res = await API.get(`/scorecard/challenges/${user.leagueid}/${week.week_number}`);
      console.log("Challenge API Response:", res.data);
      setChallenges(res.data);
      setWinners({});
    } catch (err) {
      console.error("Failed to fetch challenges", err);
    }
  };

  const handleWinnerChange = (challengeKey, winnerId) => {
    setWinners((prev) => ({
      ...prev,
      [challengeKey]: winnerId,
    }));
  };

  const handleSubmit = async () => {
    if (!selectedWeek) return;

    const payload = {
      winners: challenges.map((ch) => {
        const key = `${ch.challenge_id}_${ch.hole}`;
        return {
          leagueid: user.leagueid,
          weekid: selectedWeek.week_number,
          hole: ch.hole,
          challenge_name: ch.challenge_name,
          winner_id: winners[key],
        };
      }),
    };

    try {
      await API.post(`/scorecard/contest-winners`, payload);
      alert("Winners saved!");
    } catch (err) {
      console.error("Failed to submit winners", err);
      alert("An error occurred while saving winners.");
    }
  };

  return (
    <div className="container mt-4">
      <h2>Enter Contest Winners</h2>

      <Form.Group className="mb-3">
        <Form.Label>Select Week</Form.Label>
        <Form.Select onChange={handleWeekChange} value={selectedWeek?.id || ""}>
          <option value="">-- Select Week --</option>
          {weeks.map((week) => (
            <option key={week.id} value={week.id}>
              Week {week.week_number} - {week.date}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {selectedWeek && challenges.length === 0 && (
        <p className="mt-3 text-muted">No contests found for this week.</p>
      )}

      {challenges.length > 0 && (
        <Table striped bordered className="mt-4">
          <thead>
            <tr>
              <th>Contest</th>
              <th>Winner</th>
            </tr>
          </thead>
          <tbody>
            {challenges.map((ch) => {
              const key = `${ch.challenge_id}_${ch.hole}`;
              return (
                <tr key={key}>
                  <td>{ch.challenge_name} (Hole {ch.hole})</td>
                  <td>
                    <Form.Select
                      value={winners[key] || ""}
                      onChange={(e) => handleWinnerChange(key, e.target.value)}
                    >
                      <option value="">-- Select Player --</option>
                      {players.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.firstname} {p.lastname}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}

      {challenges.length > 0 && (
        <Button variant="primary" onClick={handleSubmit} className="mt-3">
          Save Winners
        </Button>
      )}
    </div>
  );
}

